import { ALGOLIA_API_KEY, ALGOLIA_APP_ID } from '../constants/algolia_constants';
import algoliasearch from 'algoliasearch/lite';

export const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY);